import { FC, Fragment } from "react";
import { ButtonCell, getSafeAreaInsetBottom } from "~/components";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ActionType } from "../constants";
import TokenFavoriteBtn from "./TokenFavoriteBtn";
import TokenRiskBtn, { TokenRiskBtnProps } from "./TokenRiskBtn";

interface IProps {
    className?: string;
    style?: React.CSSProperties;
    ifPlaceholder?: boolean;
    chain_id?: string;
    contract?: string;
    risk_level?: TokenRiskBtnProps["risk_level"];
    isFavorite: boolean;
    setIsFavorite: (isFavorite: boolean) => void;
    updateFavoriteCache: (isFavorite: boolean) => void;
}

export const FooterBtn: FC<IProps> = ({
    className = "",
    style = {},
    ifPlaceholder = false,
    chain_id,
    contract,
    risk_level = 0,
    isFavorite,
    setIsFavorite,
    updateFavoriteCache,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const buyEvent = () => {
        navigate(
            `/trade?chain_id=${chain_id}&contract=${contract}&action_type=${ActionType.Buy}`,
            { replace: true }
        );
    };

    const sellEvent = () => {
        navigate(
            `/trade?chain_id=${chain_id}&contract=${contract}&action_type=${ActionType.Sell}`,
            { replace: true }
        );
    };

    return (
        <Fragment>
            {ifPlaceholder && <div style={style} className={className} />}
            <div
                style={{ ...style, bottom: getSafeAreaInsetBottom() }}
                className={clsx(
                    "w-full fixed left-0 z-[10] px-[16px] bg-bg_bottom border-t-[0.5px] border-border_2",
                    className
                )}
            >
                <div className="flex items-center mt-[5px]">
                    <TokenFavoriteBtn
                        chain_id={chain_id}
                        contract={contract}
                        isFavorite={isFavorite}
                        setIsFavorite={setIsFavorite}
                        updateFavoriteCache={updateFavoriteCache}
                    />
                    <TokenRiskBtn
                        chain_id={chain_id}
                        contract={contract}
                        risk_level={risk_level}
                    />
                    <div className="w-3" />
                    <ButtonCell
                        className="px-0 block py-0 h-auto overflow-hidden"
                        onClick={buyEvent}
                    >
                        <div className="w-full flex items-center justify-center h-[44px] rounded-[12px] text-body1 font-Semibold text-white bg-Green">
                            {t("buy")}
                        </div>
                    </ButtonCell>
                    <div className="w-3" />
                    <ButtonCell
                        className="px-0 block py-0 h-auto overflow-hidden"
                        onClick={sellEvent}
                    >
                        <div className="w-full flex items-center justify-center h-[44px] rounded-[12px] text-body1 font-Semibold text-white bg-Red">
                            {t("sell")}
                        </div>
                    </ButtonCell>
                </div>
            </div>
        </Fragment>
    );
};
